// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Itinerary-container-BaMDH {
	width: var(--max-container-width);
	max-width: var(--max-listing-width);
	position: relative;
	margin: 0px auto;
}

.Itinerary-imageContent-skoT0 {
	height: 100%;
	width: 100%;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: cover;
	border-radius: 6px;
	padding-top: 54%;
}

.Itinerary-textSection-jhWXk {
	margin-left: 20px;
}

.Itinerary-avatarImage-RO3qa {
	display: grid;
	grid-template-columns: 80px auto;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Itinerary-boxSection-OdI4n {
	border: 1px solid var(--primary-border);
	padding: 24px;
	border-radius: 12px;
}

.Itinerary-displayFlexDate-ZpBbT {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.Itinerary-imgBgColor-_xltN {
	background-color: var(--common-gray-bg-color);
}

.Itinerary-dotCss-H6yEC {
	width: 4px;
	height: 4px;
	background: var(--common-background-color);
	border-radius: 50%;
	margin: 0px 4px;
	display: inline-block;
	position: relative;
	top: 0px;
}

.Itinerary-displayFlex-DXFZp {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

.Itinerary-billingArrow-Opjuz {
	margin: 0 2px;
}

.Itinerary-zIndex-Ftyy1 {
	z-index: 5;
}

.Itinerary-zIndex-Ftyy1 a {
	display: inline-block;
}

.Itinerary-discountColor-e4kVF,
.Itinerary-discountColor-e4kVF:hover,
.Itinerary-discountColor-e4kVF:focus {
	color: #3fb34f;
}

.Itinerary-specialPriceIcon-sXBM9 {
	display: inline-block;
	position: relative;
}

.Itinerary-specialPriceIcon-sXBM9:hover .Itinerary-toolTip-bGf2T {
	display: block;
}

.Itinerary-toolTip-bGf2T {
	position: absolute;
	top: -46px;
	right: 0;
	left: -5px;
	display: none;
	background: var(--common-background-color);
	min-width: 280px;
	text-align: center;
	padding: 10px;
	border-radius: 4px;
	color: var(--white-text);
}

.Itinerary-toolTipRelativeSection-PUUFj::after {
	content: '';
	height: 100%;
	width: 100%;
	position: absolute;
	left: 10px;
	right: 0;
	top: 30px;
	bottom: 0;
	text-align: center;
	background-color: var(--common-background-color);
	z-index: 1;
	max-width: 11px;
	max-height: 11px;
	-webkit-transform: rotate(136deg);
	    -ms-transform: rotate(136deg);
	        transform: rotate(136deg);
}

.Itinerary-faqImage-hQsYR {
	width: 100%;
	max-width: 19px;
	vertical-align: middle;
	margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/Itinerary/Itinerary.css"],"names":[],"mappings":"AAAA;CACC,iCAAiC;CACjC,mCAAmC;CACnC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,4BAA4B;CAC5B,4BAA4B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,uCAAuC;CACvC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,UAAU;CACV,WAAW;CACX,0CAA0C;CAC1C,kBAAkB;CAClB,eAAe;CACf,qBAAqB;CACrB,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;;CAGC,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,UAAU;CACV,aAAa;CACb,0CAA0C;CAC1C,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,gDAAgD;CAChD,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,iCAAyB;KAAzB,6BAAyB;SAAzB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,iBAAiB;AAClB","sourcesContent":[".container {\n\twidth: var(--max-container-width);\n\tmax-width: var(--max-listing-width);\n\tposition: relative;\n\tmargin: 0px auto;\n}\n\n.imageContent {\n\theight: 100%;\n\twidth: 100%;\n\tbackground-position: 50% 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tborder-radius: 6px;\n\tpadding-top: 54%;\n}\n\n.textSection {\n\tmargin-left: 20px;\n}\n\n.avatarImage {\n\tdisplay: grid;\n\tgrid-template-columns: 80px auto;\n\talign-items: center;\n}\n\n.boxSection {\n\tborder: 1px solid var(--primary-border);\n\tpadding: 24px;\n\tborder-radius: 12px;\n}\n\n.displayFlexDate {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.imgBgColor {\n\tbackground-color: var(--common-gray-bg-color);\n}\n\n.dotCss {\n\twidth: 4px;\n\theight: 4px;\n\tbackground: var(--common-background-color);\n\tborder-radius: 50%;\n\tmargin: 0px 4px;\n\tdisplay: inline-block;\n\tposition: relative;\n\ttop: 0px;\n}\n\n.displayFlex {\n\tdisplay: flex;\n}\n\n.billingArrow {\n\tmargin: 0 2px;\n}\n\n.zIndex {\n\tz-index: 5;\n}\n\n.zIndex a {\n\tdisplay: inline-block;\n}\n\n.discountColor,\n.discountColor:hover,\n.discountColor:focus {\n\tcolor: #3fb34f;\n}\n\n.specialPriceIcon {\n\tdisplay: inline-block;\n\tposition: relative;\n}\n\n.specialPriceIcon:hover .toolTip {\n\tdisplay: block;\n}\n\n.toolTip {\n\tposition: absolute;\n\ttop: -46px;\n\tright: 0;\n\tleft: -5px;\n\tdisplay: none;\n\tbackground: var(--common-background-color);\n\tmin-width: 280px;\n\ttext-align: center;\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tcolor: var(--white-text);\n}\n\n.toolTipRelativeSection::after {\n\tcontent: '';\n\theight: 100%;\n\twidth: 100%;\n\tposition: absolute;\n\tleft: 10px;\n\tright: 0;\n\ttop: 30px;\n\tbottom: 0;\n\ttext-align: center;\n\tbackground-color: var(--common-background-color);\n\tz-index: 1;\n\tmax-width: 11px;\n\tmax-height: 11px;\n\ttransform: rotate(136deg);\n}\n\n.faqImage {\n\twidth: 100%;\n\tmax-width: 19px;\n\tvertical-align: middle;\n\tmargin-right: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Itinerary-container-BaMDH`,
	"imageContent": `Itinerary-imageContent-skoT0`,
	"textSection": `Itinerary-textSection-jhWXk`,
	"avatarImage": `Itinerary-avatarImage-RO3qa`,
	"boxSection": `Itinerary-boxSection-OdI4n`,
	"displayFlexDate": `Itinerary-displayFlexDate-ZpBbT`,
	"imgBgColor": `Itinerary-imgBgColor-_xltN`,
	"dotCss": `Itinerary-dotCss-H6yEC`,
	"displayFlex": `Itinerary-displayFlex-DXFZp`,
	"billingArrow": `Itinerary-billingArrow-Opjuz`,
	"zIndex": `Itinerary-zIndex-Ftyy1`,
	"discountColor": `Itinerary-discountColor-e4kVF`,
	"specialPriceIcon": `Itinerary-specialPriceIcon-sXBM9`,
	"toolTip": `Itinerary-toolTip-bGf2T`,
	"toolTipRelativeSection": `Itinerary-toolTipRelativeSection-PUUFj`,
	"faqImage": `Itinerary-faqImage-hQsYR`
};
module.exports = ___CSS_LOADER_EXPORT___;
